module.exports = __webpack_public_path__ + "img/sld_transformer_delta_star4.ace177b4.svg";